<script setup lang="ts">
/**
 * The place on screen, as the heading of the tide, drying and info screens. Tapping it goes
 * to the place chooser: the name is where the eye goes to change place, as it does in most
 * apps, and the tab bar is the long way round.
 */
import { useAppStore } from '../store'
import ScreenTitle from './ScreenTitle.vue'

const store = useAppStore()
</script>

<template>
  <ScreenTitle>
    <router-link to="/locaties" class="placetitle">
      {{ store.place ? store.place.name : store.t('noStation') }}<span class="chev" aria-hidden="true">▾</span>
    </router-link>
    <!-- the place's own warning, one tap away for as long as the place is on screen -->
    <button v-if="store.placeWarning" type="button" class="warnbtn" :aria-label="store.t('placeWarning')" @click="store.warningOpen = true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 3.5 2.5 20h19L12 3.5z" /><path d="M12 10v4.5" /><path d="M12 17.3v.2" />
      </svg>
    </button>
  </ScreenTitle>
</template>
